<div class="stats">
    <div class="stats__inner">
        <span class="stats__item -label" *ngIf="stats?.label">{{stats?.label}}</span>
        <span class="stats__item -price" *ngIf="stats?.price">{{stats?.price | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}</span>
        <span class="stats__sep"
            *ngIf="energy && ((stats?.label !== undefined && stats?.label !== null) || (stats?.price))"></span>
        <span class="stats__item -energy" *ngIf="energy">
            {{energy}}
        </span>
    </div>
</div>
